import { render, staticRenderFns } from "./PlaySoundTest.vue?vue&type=template&id=b9a1c780&scoped=true&"
import script from "./PlaySoundTest.vue?vue&type=script&lang=js&"
export * from "./PlaySoundTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a1c780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9a1c780')) {
      api.createRecord('b9a1c780', component.options)
    } else {
      api.reload('b9a1c780', component.options)
    }
    module.hot.accept("./PlaySoundTest.vue?vue&type=template&id=b9a1c780&scoped=true&", function () {
      api.rerender('b9a1c780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Device/Settings/PlaySoundTest.vue"
export default component.exports